<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>科普宣教库</el-breadcrumb-item>
      <el-breadcrumb-item>文章列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="margin: 20px 0;">
      <el-input
        v-model="searchTitle"
        placeholder="请输入文章标题关键字"
        style="width: 300px;"
        clearable
        @keyup.enter.native="handleSearch"
      >
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>
      <el-button v-if="isSearching" style="margin-left: 10px;" @click="handleReset">重置</el-button>
    </div>

    <el-form :inline="true" size="small" style="margin-bottom: 15px;">
      <el-form-item label="宣教类型">
        <el-select
          v-model="filterArticleType"
          placeholder="全部"
          clearable
          style="width: 140px"
          @change="onFilterArticleTypeChange"
        >
          <el-option label="机器人宣教" value="robot"></el-option>
          <el-option label="普通宣教" value="normal"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="filterFirstCategory"
          placeholder="全部"
          clearable
          style="width: 160px"
          @change="onFilterFirstCategoryChange"
        >
          <el-option
            v-for="item in filterFirstCategoryOptions"
            :key="item.firstId"
            :label="item.firstName"
            :value="item.firstId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="filterSecondCategory"
          placeholder="全部"
          clearable
          :disabled="!filterFirstCategory"
          style="width: 160px"
        >
          <el-option
            v-for="item in filterSecondCategoryOptions"
            :key="item.id"
            :label="item.secName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="医院">
        <el-select
          v-model="filterHospital"
          placeholder="全部"
          clearable
          style="width: 180px"
          @change="onFilterHospitalChange"
        >
          <el-option
            v-for="item in filterHospitalOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科室">
        <el-select
          v-model="filterDepartment"
          placeholder="全部"
          clearable
          :disabled="!filterHospital"
          style="width: 160px"
        >
          <el-option
            v-for="item in filterDepartmentOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleFilter">筛选</el-button>
        <el-button icon="el-icon-refresh" @click="handleFilterReset">重置筛选</el-button>
      </el-form-item>
    </el-form>

    <el-tabs v-if="isSearching" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="机器人" name="robot"></el-tab-pane>
      <el-tab-pane label="普通" name="normal"></el-tab-pane>
    </el-tabs>

    <div style="margin-bottom: 10px;" v-if="selectedArticles.length > 0">
      <el-alert
        :title="'已选择 ' + selectedArticles.length + ' 篇文章'"
        type="info"
        :closable="false"
        show-icon
        style="display: inline-flex; margin-right: 12px; vertical-align: middle;"
      ></el-alert>
      <el-button
        type="warning"
        size="small"
        icon="el-icon-setting"
        @click="handleBatchScopeClick"
      >批量设置可见范围</el-button>
      <el-button
        size="small"
        @click="$refs.articleTable.clearSelection()"
      >取消选择</el-button>
    </div>

    <el-table
      ref="articleTable"
      :data="articles"
      style="width: 100%;"
      height="630"
      stripe
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="45"
      ></el-table-column>
      <el-table-column
        prop="createDate"
        label="录入时间"
        width="120"
      >
      </el-table-column>

      <el-table-column
        label="所属分类"
        width="260"
        align="center"
      >

        <template slot-scope="scope">

          <el-tag
            style="margin-bottom:4px"
            v-for="item in scope.row.categories"
            :key="item.id"
            closable
            size="mini"
            @close="closeCategory(scope.row,item)"
          >
            {{item.type + ' -- ' + item.firstName + ' --  ' + item.secondName}}
          </el-tag>

        </template>
      </el-table-column>

      <el-table-column
        label="绑定医院科室"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.scopeList && scope.row.scopeList.length > 0">
            <el-tag
              v-for="s in scope.row.scopeList"
              :key="s.id"
              size="mini"
              type="warning"
              style="margin: 2px"
            >{{ s.hospitalName || '全局' }}{{ s.departmentName ? ' - ' + s.departmentName : '' }}</el-tag>
          </template>
          <span v-else style="color:#999;font-size:12px">全局可见</span>
        </template>
      </el-table-column>

      <el-table-column
        label="标签"
        width="260"
        align="center"
      >

        <template slot-scope="scope">

          <div
            v-for="items in scope.row.tags"
            :key="items.id"
          >
            <el-tag
              style="margin-bottom:4px;margin-left:4px;margin-right:4px"
              v-for="tag in items.categoryTagRespList"
              :key="tag.id"
              closable
              size="mini"
              @close="closeTag(scope.row,tag)"
            >
              {{tag.name}}
            </el-tag>
          </div>

        </template>
      </el-table-column>

      <el-table-column
        prop="title"
        label="标题"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="author"
        label="作者"
        width="150"
      >
        <!-- <template slot-scope="scope">

          <el-link
            slot="reference"
            class="name-wrapper"
            :href="scope.row.videoUrl "
            target="_blank"
          > {{ scope.row.title }}</el-link>

        </template> -->
      </el-table-column>

      <el-table-column
        label="引用链接"
        width="80"
      >
        <template slot-scope="scope">
          <el-link
            slot="reference"
            class="name-wrapper"
            type="primary"
            :href="scope.row.refLink"
            target="_blank"
            :disabled="scope.row.refLink === '' ? true : false"
          > {{scope.row.refLink === '' ? '无' : '查看'}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        label="摘要"
        width="250"
      >
        <template slot-scope="scope">

          <el-tooltip placement="top">
            <div
              slot="content"
              style="max-width:200px;line-height:18px"
            >{{scope.row.brief}}</div>
            <span>{{scope.row.brief.substring(0,30)+"..."}}</span>
          </el-tooltip>

        </template>
      </el-table-column>

      <!-- <el-table-column
        label="详情"
        width="100"
      >
        <template slot-scope="scope">

          <el-button
            size="mini"
            slot="reference"
            class="name-wrapper"
            @click="onArticleShowClick(scope.$index, scope.row)"
            type="success"
          >查看</el-button>

        </template>
      </el-table-column> -->

      <el-table-column
        label="上架状态"
        width="100"
      > <template slot-scope="scope">

          <el-button
            size="mini"
            slot="reference"
            class="name-wrapper"
            @click="onActiveClick(scope.$index, scope.row)"
            :type="scope.row.active ? 'success' : 'info'"
          >{{scope.row.active?"已上架":"未上架"}}</el-button>

          <!-- <el-link
            slot="reference"
            class="name-wrapper"
            :href="scope.row. refLink"
            target="_blank"
          > 查看</el-link> -->

        </template></el-table-column>
      <el-table-column
        prop="readCount"
        label="阅读数"
        width="100"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <div>

            <el-button
              @click="handleArticleEditClick(scope.row)"
              type="text"
              size="small"
            >编辑</el-button>
            <el-button
              @click="handleArticleCategoriesClick(scope.row)"
              type="text"
              size="small"
            >绑定分类/标签</el-button>
            <el-button
              @click="handleArticleScopeClick(scope.row)"
              type="text"
              size="small"
            >可见范围</el-button>
            <el-button
              @click="handleArticleDeleteClick(scope.row)"
              type="text"
              size="small"
            >删除</el-button>
          </div>

        </template>
      </el-table-column>

    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <el-dialog
      title="设置文章的[分类/标签]"
      :visible.sync="dialogCategorySettingVisible"
    >
      <el-divider content-position="left">入院宣教</el-divider>
      <el-row
        :gutter="20"
        style="color:#24a631"
      >
        <el-col :span="10">
          请选择分类
        </el-col>

        <el-col :span="14">
          请选择标签
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="10">
          <el-cascader
            v-model="ruyuanCategory"
            :options="ruyuanCategoryOptions"
            @change="ruyuanCategoryChange"
          ></el-cascader>
        </el-col>

        <el-col :span="14">
          <el-checkbox-group v-model="ruyuanCheckList">
            <el-checkbox
              v-for="(item) in ruyuanCheckOptions"
              :key="item.id"
              :label="item.name"
            ></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-divider content-position="left">机器人宣教</el-divider>
      <el-row
        :gutter="20"
        style="color:#24a631"
      >
        <el-col :span="10">
          请选择分类
        </el-col>

        <el-col :span="14">
          请选择标签
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="10">
          <el-cascader
            v-model="robotCategory"
            :options="robotCategoryOptions"
            @change="robotCategoryChange"
          ></el-cascader>
        </el-col>

        <el-col :span="14">
          <el-checkbox-group v-model="robotCheckList">
            <el-checkbox
              v-for="(item) in robotCheckOptions"
              :key="item.id"
              :label="item.name"
            ></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-divider content-position="left">资讯文章(开发中) </el-divider>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogCategorySettingVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onCategorySettingCommit"
        >绑定分类</el-button>
        <el-button
          type="primary"
          @click="onLabelSettingCommit"
        >绑定标签</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="设置文章可见范围"
      :visible.sync="dialogScopeVisible"
      width="600px"
    >
      <div v-if="scopeArticle">
        <p style="margin-bottom:10px;color:#666">
          文章：<strong>{{ scopeArticle.title }}</strong>
        </p>

        <el-divider content-position="left">已配置的可见范围</el-divider>

        <el-table
          :data="scopeList"
          border
          size="small"
          style="width: 100%; margin-bottom: 20px"
          empty-text="未配置（默认全局可见）"
        >
          <el-table-column label="医院" prop="hospitalName">
            <template slot-scope="scope">
              {{ scope.row.hospitalName || '（全局）' }}
            </template>
          </el-table-column>
          <el-table-column label="科室" prop="departmentName">
            <template slot-scope="scope">
              {{ scope.row.departmentName || '（不限科室）' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color:#F56C6C"
                @click="handleDeleteScope(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-divider content-position="left">添加可见范围</el-divider>

        <el-form :inline="true" size="small">
          <el-form-item label="医院">
            <el-select
              v-model="scopeForm.hospitalName"
              placeholder="请选择医院"
              clearable
              style="width:200px"
              @change="onScopeHospitalChange"
            >
              <el-option
                v-for="item in scopeHospitalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科室">
            <el-select
              v-model="scopeForm.departmentName"
              placeholder="请选择科室"
              clearable
              :disabled="!scopeForm.hospitalName"
              style="width:200px"
            >
              <el-option
                v-for="item in scopeDepartmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAddScope">添加</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogScopeVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量设置文章可见范围"
      :visible.sync="dialogBatchScopeVisible"
      width="650px"
    >
      <div>
        <el-alert
          :title="'已选择 ' + selectedArticles.length + ' 篇文章'"
          type="info"
          :closable="false"
          show-icon
          style="margin-bottom: 16px;"
        ></el-alert>

        <el-table
          :data="selectedArticles"
          border
          size="small"
          max-height="200"
          style="width: 100%; margin-bottom: 16px;"
        >
          <el-table-column prop="title" label="文章标题" min-width="200"></el-table-column>
          <el-table-column label="当前可见范围" min-width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.scopeList && scope.row.scopeList.length > 0">
                <el-tag
                  v-for="s in scope.row.scopeList"
                  :key="s.id"
                  size="mini"
                  type="warning"
                  style="margin: 2px"
                >{{ s.hospitalName || '全局' }}{{ s.departmentName ? ' - ' + s.departmentName : '' }}</el-tag>
              </template>
              <span v-else style="color:#999;font-size:12px">全局可见</span>
            </template>
          </el-table-column>
        </el-table>

        <el-divider content-position="left">要添加的可见范围</el-divider>

        <el-table
          :data="batchScopeList"
          border
          size="small"
          style="width: 100%; margin-bottom: 12px"
          empty-text="请在下方添加可见范围"
        >
          <el-table-column label="医院">
            <template slot-scope="scope">
              {{ scope.row.hospitalName || '（全局）' }}
            </template>
          </el-table-column>
          <el-table-column label="科室">
            <template slot-scope="scope">
              {{ scope.row.departmentName || '（不限科室）' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color:#F56C6C"
                @click="batchScopeList.splice(scope.$index, 1)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-form :inline="true" size="small">
          <el-form-item label="医院">
            <el-select
              v-model="batchScopeForm.hospitalName"
              placeholder="请选择医院"
              clearable
              style="width:200px"
              @change="onBatchScopeHospitalChange"
            >
              <el-option
                v-for="item in batchScopeHospitalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科室">
            <el-select
              v-model="batchScopeForm.departmentName"
              placeholder="请选择科室"
              clearable
              :disabled="!batchScopeForm.hospitalName"
              style="width:200px"
            >
              <el-option
                v-for="item in batchScopeDepartmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAddBatchScope">添加</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBatchScopeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="batchScopeSubmitting"
          @click="handleBatchScopeSubmit"
        >确认提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {

  data () {
    return {
      articles: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      canDelete: false,
      dialogCategorySettingVisible: false,
      currentArticle: null,
      ruyuanCategory: [],
      ruyuanCategoryOptions: [],
      ruyuanCheckOptions: [],
      ruyuanCheckList: [],
      ruyuanLabelCheckIds: [],
      robotCategory: [],
      robotCategoryOptions: [],
      robotCheckOptions: [],
      robotCheckList: [],
      robotLabelCheckIds: [],
      searchTitle: '',
      isSearching: false,
      activeTab: 'robot',
      searchResultAll: [],
      filterArticleType: 'robot',
      filterFirstCategory: '',
      filterSecondCategory: '',
      filterHospital: '',
      filterDepartment: '',
      filterFirstCategoryOptions: [],
      filterSecondCategoryOptions: [],
      filterHospitalOptions: [],
      filterDepartmentOptions: [],
      filterDepartmentsByHospital: {},
      isFiltering: false,
      allArticlesCache: [],
      dialogScopeVisible: false,
      scopeArticle: null,
      scopeList: [],
      scopeForm: {
        hospitalName: '',
        departmentName: ''
      },
      scopeHospitalOptions: [],
      scopeDepartmentOptions: [],
      scopeDepartmentsByHospital: {},
      selectedArticles: [],
      dialogBatchScopeVisible: false,
      batchScopeForm: {
        hospitalName: '',
        departmentName: ''
      },
      batchScopeHospitalOptions: [],
      batchScopeDepartmentOptions: [],
      batchScopeDepartmentsByHospital: {},
      batchScopeList: [],
      batchScopeSubmitting: false
    }
  },
  created () {
    this.loadArticles()
    this.loadFilterCategories()
    this.loadFilterHospitalDepartments()
  },
  methods: {
    async loadArticles () {
      const { data: resp } = await this.$http.get('cms/article/list', { params: { page: this.currentPage, pageSize: this.pageSize } })
      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)

      resp.data.data.forEach(e => {
        e.createDate = new Date(e.createDate).toLocaleDateString() + ' ' + new Date(e.createDate).toLocaleTimeString()
      })

      this.articles = resp.data.data
      this.currentPage = resp.data.page
      this.pageSize = resp.data.pageSize
      this.total = resp.data.total
      await this.loadArticleScopes4List(this.articles)
    },
    async loadArticleScopes4List (articles) {
      if (!articles || articles.length === 0) return
      const ids = articles.map(a => a.id)
      try {
        const { data: resp } = await this.$http.get('article/scope/batch_find', {
          params: { articleIds: ids.join(',') }
        })
        if (resp.code !== 200) return
        const scopeMap = resp.data || {}
        articles.forEach(article => {
          const scopes = scopeMap[article.id] || []
          this.$set(article, 'scopeList', scopes)
        })
      } catch (e) {
        console.warn('loadArticleScopes4List failed', e)
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      if (!this.isFiltering && !this.isSearching) {
        this.loadArticles()
      }
    },
    async onActiveClick (index, row) {
      // console.log(value)
      console.log(index)
      console.log(row)

      const loading = this.$message({
        message: '操作中',
        duration: 0
      })

      const { data: resp } = await this.$http.get('cms/article/active', { params: { id: row.id, active: row.active } })

      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)

      row.active = resp.data

      loading.close()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    handleArticleShowClick (row) {
      // this.$router.push('/article/' + row.id)

      const routeData = this.$router.resolve({
        path: '/article/' + row.id,
        name: 'article'
      })
      window.open(routeData.href, '_blank')
    },
    async handleArticleDeleteClick (row) {
      if (!this.canDelete) {
        return this.$message({
          message: '暂不提供删除功能',
          type: 'warning'
        })
      }

      if (row.active) {
        return this.$message({
          showClose: true,
          message: '正在上架的文章不可删除',
          type: 'warning'
        })
      }
      const loading = this.$message({
        message: '操作中',
        duration: 0
      })

      const { data: resp } = await this.$http.delete('cms/article/delete', { params: { id: row.id } })

      console.log(resp)
      loading.close()

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.articles.forEach(article => {
        if (article.id === row.id) {
          this.articles.splice(this.articles.indexOf(article), 1)
        }
      })

      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    handleArticleCategoriesClick (row) {
      // 打开分类、标签的修改界面
      this.dialogCategorySettingVisible = true
      this.currentArticle = row
      console.log('handleArticleCategoriesClick', this.currentArticle)

      this.loadRuyuanCategories()
      this.loadRobotCategories()
      this.ruyuanCategory = []
      this.robotCategory = []
      this.ruyuanCheckList = []
      this.robotCheckList = []
      this.ruyuanCheckOptions = []
      this.robotCheckOptions = []
    },
    async onLabelSettingCommit () {
      const articleId = this.currentArticle.id
      let categoryId = null
      let labelCheckIds = []

      if (this.ruyuanCategory && this.ruyuanCategory.length > 1) {
        categoryId = this.ruyuanCategory[1]
        this.ruyuanCheckList.forEach(checked => {
          this.ruyuanCheckOptions.forEach(option => {
            if (checked === option.name) {
              labelCheckIds.push(option.id)
            }
          })
        })
      } else if (this.robotCategory && this.robotCategory.length > 1) {
        categoryId = this.robotCategory[1]
        this.robotCheckList.forEach(checked => {
          this.robotCheckOptions.forEach(option => {
            if (checked === option.name) {
              labelCheckIds.push(option.id)
            }
          })
        })
      }

      if (!categoryId) {
        return this.$message.warning('请先选择分类')
      }

      if (labelCheckIds.length === 0) {
        return this.$message.warning('请至少选择一个标签')
      }

      this.bindArticleLabels(articleId, categoryId, labelCheckIds)
      this.loadArticles()
    },
    async onCategorySettingCommit () {
      console.log('onCategorySettingCommit', this.currentArticle)
      const articleId = this.currentArticle.id
      let categoryId = null
      
      if (this.ruyuanCategory && this.ruyuanCategory.length > 1) {
        categoryId = this.ruyuanCategory[1]
      } else if (this.robotCategory && this.robotCategory.length > 1) {
        categoryId = this.robotCategory[1]
      }

      if (!categoryId) {
        return this.$message.warning('请先选择分类')
      }

      const { data: resp } = await this.$http.post('category/binding/article_and_category', null,
        {
          params: {
            articleId: articleId,
            categoryId: categoryId
          }
        })
      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)

      this.$message.success('修改成功')
      this.loadArticles()
    },
    async ruyuanCategoryChange (value) {
      console.log('ruyuanCategoryChange', value)
      const params = {
        categoryId: value[1],
        role: 0
      }
      const { data: resp } = await this.$http.get('article_category_tag/find/category_tag', {
        params
      })

      console.log(resp)

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.ruyuanCheckOptions = resp.data
      this.ruyuanCheckOptions.forEach(option => {
        option.checked = false
      })
    },
    async loadRuyuanCategories () {
      const { data: resp } = await this.$http.get('category/categories', {
        params: {
          type: 'a',
          row: 0
        }
      })

      console.log(resp)

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.ruyuanCategoryOptions = resp.data
    },
    async loadRobotCategories () {
      const params = { type: 'a', role: 0 }
      params.showInRobot = true
      const { data: resp } = await this.$http.get('category/find/first_category', {
        params
      })

      console.log('loadRobotCategories first_category response:', resp)

      if (resp.code !== 200) return this.$message.error(resp.message)

      const firstCategories = resp.data || []
      const categoryOptions = []

      for (const firstCat of firstCategories) {
        const secParams = { firstId: firstCat.firstId, role: 0 }
        secParams.showInRobot = true
        const { data: secResp } = await this.$http.get('category/find/sec_category', {
          params: secParams
        })

        console.log('loadRobotCategories sec_category response:', secResp)

        if (secResp.code === 200 && secResp.data) {
          const children = secResp.data.map(sec => ({
            value: sec.id,
            label: sec.secName
          }))

          categoryOptions.push({
            value: firstCat.firstId,
            label: firstCat.firstName,
            children: children
          })
        }
      }

      console.log('robotCategoryOptions:', categoryOptions)
      this.robotCategoryOptions = categoryOptions
    },
    async robotCategoryChange (value) {
      console.log('robotCategoryChange', value)
      const params = {
        categoryId: value[1],
        role: 0,
        showInRobot: true
      }
      const { data: resp } = await this.$http.get('article_category_tag/find/category_tag', {
        params
      })

      console.log(resp)

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.robotCheckOptions = resp.data
      this.robotCheckOptions.forEach(option => {
        option.checked = false
      })
    },
    async closeCategory (article, category) {
      console.log('删除分类: ', article.id, category.id)
      const { data: resp } = await this.$http.delete('category/unbinding/article_and_category', {
        params: {
          articleId: article.id, categoryId: category.id
        }
      })

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.$message.success('目录解绑成功')

      this.loadArticles()
    },
    async bindArticleLabels (articleId, categoryId, labelCheckIds) {
      console.log(labelCheckIds)
      let ids = ''
      labelCheckIds.forEach(id => {
        ids += id + ','
      })
      ids = ids.substring(0, ids.length - 1)
      console.log(ids)
      const { data: resp } = await this.$http.post('article_category_tag/binding/singleCategory/article_and_category_tag?categoryId=' + categoryId + '&articleId=' + articleId + '&tagIdList=' + ids
      )

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.$message.success('标签绑定成功')
    },
    async closeTag (article, tag) {
      console.log(tag)
      console.log('删除标签: ', article.id, tag.id)

      const { data: resp } = await this.$http.delete('article_category_tag/unbinding/article_tag', {
        params: {
          articleId: article.id, tagId: tag.id
        }
      })

      if (resp.code !== 200) return this.$message.error(resp.message)

      this.$message.success('目录解绑成功')

      this.loadArticles()
    },
    async handleArticleScopeClick (row) {
      this.scopeArticle = row
      this.scopeForm = { hospitalName: '', departmentName: '' }
      this.scopeDepartmentOptions = []
      this.dialogScopeVisible = true
      await Promise.all([this.loadArticleScopes(row.id), this.loadHospitalDepartments()])
    },
    async loadArticleScopes (articleId) {
      const { data: resp } = await this.$http.get('article/scope/find', {
        params: { articleId }
      })
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.scopeList = resp.data || []
      const article = this.articles.find(a => a.id === articleId)
      if (article) {
        this.$set(article, 'scopeList', this.scopeList)
      }
    },
    async loadHospitalDepartments () {
      const { data: resp } = await this.$http.get('article/scope/hospital_departments')
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.scopeHospitalOptions = resp.data.hospitals || []
      this.scopeDepartmentsByHospital = resp.data.departmentsByHospital || {}
    },
    onScopeHospitalChange () {
      this.scopeForm.departmentName = ''
      const opts = this.scopeDepartmentsByHospital[this.scopeForm.hospitalName] || []
      this.scopeDepartmentOptions = opts
    },
    async handleAddScope () {
      if (!this.scopeArticle) return

      const params = { articleId: this.scopeArticle.id }
      if (this.scopeForm.hospitalName) {
        params.hospitalName = this.scopeForm.hospitalName
        if (this.scopeForm.departmentName) {
          params.departmentName = this.scopeForm.departmentName
        }
      }
      // 全局可见时不传 hospitalName/departmentName，后端视为 null

      const { data: resp } = await this.$http.post('article/scope/save', null, { params })
      if (resp.code !== 200) return this.$message.error(resp.message)

      this.$message.success('添加成功')
      this.scopeForm = { hospitalName: '', departmentName: '' }
      await this.loadArticleScopes(this.scopeArticle.id)
    },
    async handleDeleteScope (scopeRow) {
      const { data: resp } = await this.$http.delete('article/scope/delete', {
        params: { id: scopeRow.id }
      })
      if (resp.code !== 200) return this.$message.error(resp.message)

      this.$message.success('删除成功')
      await this.loadArticleScopes(this.scopeArticle.id)
    },
    async handleSearch () {
      if (!this.searchTitle.trim()) {
        this.$message.warning('请输入搜索关键字')
        return
      }
      
      const { data: resp } = await this.$http.get('cms/article/searchByTitle', {
        params: { title: this.searchTitle }
      })

      if (resp.code !== 200) return this.$message.error(resp.message)

      resp.data.forEach(e => {
        e.createDate = new Date(e.createDate).toLocaleDateString() + ' ' + new Date(e.createDate).toLocaleTimeString()
      })

      this.searchResultAll = resp.data
      this.isSearching = true
      this.activeTab = 'robot'
      await this.loadArticleScopes4List(this.searchResultAll)
      this.filterArticlesByTab()
    },
    handleReset () {
      this.searchTitle = ''
      this.isSearching = false
      this.currentPage = 1
      this.searchResultAll = []
      this.activeTab = 'robot'
      this.loadArticles()
    },
    handleTabClick () {
      this.filterArticlesByTab()
    },
    filterArticlesByTab () {
      if (this.activeTab === 'robot') {
        this.articles = this.searchResultAll.filter(article => {
          return article.categories.some(cat => cat.showInRobot === true)
        })
      } else {
        this.articles = this.searchResultAll.filter(article => {
          return !article.categories.some(cat => cat.showInRobot === true)
        })
      }
      this.total = this.articles.length
    },
    async loadFilterCategories () {
      const params = { type: 'a', role: 0 }
      if (this.filterArticleType === 'robot') {
        params.showInRobot = true
      }
      const { data: resp } = await this.$http.get('category/find/first_category', { params })
      if (resp.code !== 200) return
      this.filterFirstCategoryOptions = resp.data || []
    },
    onFilterArticleTypeChange () {
      this.filterFirstCategory = ''
      this.filterSecondCategory = ''
      this.filterFirstCategoryOptions = []
      this.filterSecondCategoryOptions = []
      this.loadFilterCategories()
    },
    async onFilterFirstCategoryChange (val) {
      this.filterSecondCategory = ''
      this.filterSecondCategoryOptions = []
      if (!val) return
      const params = { firstId: val, role: 0 }
      if (this.filterArticleType === 'robot') {
        params.showInRobot = true
      }
      const { data: resp } = await this.$http.get('category/find/sec_category', { params })
      if (resp.code !== 200) return
      this.filterSecondCategoryOptions = resp.data || []
    },
    async loadFilterHospitalDepartments () {
      const { data: resp } = await this.$http.get('article/scope/hospital_departments')
      if (resp.code !== 200) return
      const hospitals = (resp.data.hospitals || []).filter(h => h.value !== '')
      this.filterHospitalOptions = hospitals
      this.filterDepartmentsByHospital = resp.data.departmentsByHospital || {}
    },
    onFilterHospitalChange (val) {
      this.filterDepartment = ''
      if (!val) {
        this.filterDepartmentOptions = []
        return
      }
      const opts = this.filterDepartmentsByHospital[val] || []
      this.filterDepartmentOptions = opts.filter(o => o.value !== '')
    },
    async handleFilter () {
      const hasType = !!this.filterArticleType
      const hasCategory = this.filterFirstCategory || this.filterSecondCategory
      const hasScope = this.filterHospital

      if (!hasType && !hasCategory && !hasScope) {
        this.$message.warning('请至少选择一个筛选条件')
        return
      }

      if (hasCategory && !this.filterSecondCategory) {
        this.$message.warning('请选择二级分类')
        return
      }

      this.isFiltering = true
      this.isSearching = false
      this.searchTitle = ''

      const loading = this.$loading({ lock: true, text: '筛选中...', background: 'rgba(255,255,255,0.7)' })

      try {
        let filtered = []

        if (this.filterSecondCategory) {
          const { data: resp } = await this.$http.get('ruYuanXuanJiao/articles', {
            params: {
              categoryId: this.filterSecondCategory,
              page: 1,
              pageSize: 9999,
              tags: ''
            }
          })
          if (resp.code !== 200) {
            this.$message.error(resp.message)
            return
          }
          filtered = resp.data.data || []
          filtered.forEach(e => {
            e.createDate = new Date(e.createDate).toLocaleDateString() + ' ' + new Date(e.createDate).toLocaleTimeString()
          })
        } else {
          const { data: listResp } = await this.$http.get('cms/article/list', {
            params: { page: 1, pageSize: 9999 }
          })
          if (listResp.code !== 200) {
            this.$message.error(listResp.message)
            return
          }
          filtered = listResp.data.data || []
          filtered.forEach(e => {
            e.createDate = new Date(e.createDate).toLocaleDateString() + ' ' + new Date(e.createDate).toLocaleTimeString()
          })
        }

        if (this.filterArticleType === 'robot') {
          filtered = filtered.filter(article => {
            return article.categories && article.categories.some(cat => cat.showInRobot === true)
          })
        } else if (this.filterArticleType === 'normal') {
          filtered = filtered.filter(article => {
            return !article.categories || !article.categories.some(cat => cat.showInRobot === true)
          })
        }

        if (this.filterHospital) {
          const { data: scopeResp } = await this.$http.get('article/scope/visible_article_ids', {
            params: {
              hospitalName: this.filterHospital,
              departmentName: this.filterDepartment || undefined
            }
          })

          if (scopeResp.code === 200) {
            const visibleIds = new Set(scopeResp.data.visibleIds || [])
            const allScopedIds = new Set(scopeResp.data.allScopedIds || [])
            filtered = filtered.filter(article => {
              if (visibleIds.has(article.id)) return true
              if (!allScopedIds.has(article.id)) return true
              return false
            })
          }
        }

        await this.loadArticleScopes4List(filtered)
        this.articles = filtered
        this.total = filtered.length
      } finally {
        loading.close()
      }
    },
    handleSelectionChange (val) {
      this.selectedArticles = val
    },
    async handleBatchScopeClick () {
      if (this.selectedArticles.length === 0) {
        return this.$message.warning('请先选择文章')
      }
      this.batchScopeForm = { hospitalName: '', departmentName: '' }
      this.batchScopeDepartmentOptions = []
      this.batchScopeList = []
      this.dialogBatchScopeVisible = true
      await this.loadBatchScopeHospitalDepartments()
    },
    async loadBatchScopeHospitalDepartments () {
      const { data: resp } = await this.$http.get('article/scope/hospital_departments')
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.batchScopeHospitalOptions = resp.data.hospitals || []
      this.batchScopeDepartmentsByHospital = resp.data.departmentsByHospital || {}
    },
    onBatchScopeHospitalChange () {
      this.batchScopeForm.departmentName = ''
      this.batchScopeDepartmentOptions = this.batchScopeDepartmentsByHospital[this.batchScopeForm.hospitalName] || []
    },
    handleAddBatchScope () {
      const item = {
        hospitalName: this.batchScopeForm.hospitalName || null,
        departmentName: this.batchScopeForm.departmentName || null
      }
      const exists = this.batchScopeList.some(
        s => s.hospitalName === item.hospitalName && s.departmentName === item.departmentName
      )
      if (exists) {
        return this.$message.warning('该范围已添加')
      }
      this.batchScopeList.push(item)
      this.batchScopeForm = { hospitalName: '', departmentName: '' }
      this.batchScopeDepartmentOptions = []
    },
    async handleBatchScopeSubmit () {
      if (this.batchScopeList.length === 0) {
        return this.$message.warning('请至少添加一条可见范围')
      }
      this.batchScopeSubmitting = true
      const articleIds = this.selectedArticles.map(a => a.id).join(',')
      let successCount = 0
      let failCount = 0

      try {
        for (const scope of this.batchScopeList) {
          const params = { articleIds }
          if (scope.hospitalName) {
            params.hospitalName = scope.hospitalName
            if (scope.departmentName) {
              params.departmentName = scope.departmentName
            }
          }
          const { data: resp } = await this.$http.post('article/scope/batch_save', null, { params })
          if (resp.code === 200) {
            successCount++
          } else {
            failCount++
          }
        }

        if (failCount === 0) {
          this.$message.success(`批量设置成功，共 ${this.selectedArticles.length} 篇文章 × ${successCount} 条范围`)
        } else {
          this.$message.warning(`部分失败：成功 ${successCount} 条，失败 ${failCount} 条`)
        }

        this.dialogBatchScopeVisible = false
        await this.loadArticleScopes4List(this.articles)
        this.$refs.articleTable.clearSelection()
      } catch (e) {
        this.$message.error('批量设置失败：' + e.message)
      } finally {
        this.batchScopeSubmitting = false
      }
    },
    handleArticleEditClick (row) {
      this.$router.push({ path: '/menu/content/articleEdit/' + row.id })
    },
    handleFilterReset () {
      this.filterArticleType = ''
      this.filterFirstCategory = ''
      this.filterSecondCategory = ''
      this.filterHospital = ''
      this.filterDepartment = ''
      this.filterFirstCategoryOptions = []
      this.filterSecondCategoryOptions = []
      this.filterDepartmentOptions = []
      this.isFiltering = false
      this.currentPage = 1
      this.loadFilterCategories()
      this.loadArticles()
    }

  }

}
</script>

<style lang="less" scoped>
</style>
